import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = { class: "d-block text-end" };
const _hoisted_4 = {
    key: 0,
    class: "fw-light text-muted fst-italic"
};
const _hoisted_5 = { key: 1 };
const _hoisted_6 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Alert = _resolveComponent("Alert");
    return (_ctx.messages.length <= 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", {
                class: "mb-0",
                style: { "overflow": "hidden", "text-overflow": "ellipsis" },
                innerHTML: _ctx.messages[0].message
            }, null, 8, _hoisted_2),
            _createElementVNode("span", _hoisted_3, [
                (_ctx.messages[0].datetime !== undefined)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.messages[0].datetime), 1))
                    : _createCommentVNode("", true)
            ])
        ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (simpleMsg) => {
                return (_openBlock(), _createBlock(_component_Alert, {
                    key: simpleMsg.message,
                    type: simpleMsg.variant,
                    extraClasses: "p-2 mb-2"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", {
                            innerHTML: _ctx.alertTxt(simpleMsg)
                        }, null, 8, _hoisted_6)
                    ]),
                    _: 2
                }, 1032, ["type"]));
            }), 128))
        ]));
}
